const images = {
  Group: require("./Assets/Images/Group.svg").default,
  GroupIcon: require("./Assets/Images/GroupIcon.svg").default,
  StarRatingYellow: require("./Assets/Images/StarRatingYellow.svg").default,
  StarRatingGray: require("./Assets/Images/StarRatingGray.svg").default,
  cancelButton: require("./Assets/Images/cancelButton.svg").default,
  ErrorSign: require("./Assets/Images/ErrorSign.svg").default,
  PageNotFound: require("./Assets/Images/page-not-found-img.svg").default,
  Delete: require("./Assets/Images/Delete.svg").default,
  thankyou: require("./Assets/Images/thankyou.svg").default,
  surveyExpiration: require("./Assets/Images/surveyExpiration.svg").default,
  surveySubmitted: require("./Assets/Images/surveySubmitted.svg").default,
  CloudUpload: require("./Assets/Images/CloudUpload.svg").default,
  PdfDownload: require("./Assets/Images/PdfDownload.svg").default,
  deleteAlert: require("./Assets/Images/deleteAlert.svg").default,
  clearBroom: require("./Assets/Images/clearBroom.svg").default,
  ClearAnswerIcon: require("./Assets/Images/ClearAnswerIcon.svg").default,
  attachmentUpload: require("./Assets/Images/attachmentUpload.svg").default,
  InformationTooltip: require("./Assets/Images/InformationTooltip.svg").default,
  pdfFile: require("./Assets/Images/pdfFile.svg").default,
  responseUpload: require("./Assets/Images/responseUpload.svg").default,
  UploadClear: require("./Assets/Images/UploadClear.svg").default,
  ilpaQuestion: require("./Assets/Images/ilpaQuestion.svg").default,
  NoCreateAndChoosequestion:
    require("./Assets/Images/NoCreateAndChoosequestion.svg").default,
  pdfSize: require("./Assets/Images/pdf-size.svg").default,
  whiteArrow: require("./Assets/Images/RightArrowWhite.svg").default,
  Ellipse: require("./Assets/Images/Ellipse2.svg").default,
  next: require("./Assets/Images/nextArrow.svg").default,
  previous: require("./Assets/Images/prevArrow.svg").default,
  dot: require("./Assets/Images/3Dot.svg").default,
  back: require("./Assets/Images/back.svg").default,
  square: require("./Assets/Images/square.svg").default,
  companyInfoImg: require("./Assets/Images/companyInfoImg.svg").default,
  download: require("./Assets/Images/downloadPdf.svg").default,
  mailIcon: require("./Assets/Images/mailIcon.svg").default,
  phoneIcon: require("./Assets/Images/phoneIcon.svg").default,
  location: require("./Assets/Images/location.svg").default,
  otpScreen: require("./Assets/Images/otpScreen.svg").default,
  MobileOtpScreen: require("./Assets/Images/OTPmobileImg.svg").default,
  path: require("./Assets/Images/Path.svg").default,
  attachment: require("./Assets/Images/attachment.svg").default,
  EditBlue: require("./Assets/Images/EditBlue.svg").default,
  addButton: require("./Assets/Images/addButton.svg").default,
  landscape: require("./Assets/Images/landscapeRotate.svg").default,
  edit: require("./Assets/Images/EditBlueImg.svg").default,
  ToggleSwitchOff: require("./Assets/Images/ToggleSwitchOff.svg").default,
  ToggleSwitchOn: require("./Assets/Images/ToggleSwitchOn.svg").default,
  taggedResponse: require("./Assets/Images/taggedResponse.svg").default,
  noteCarryForward: require("./Assets/Images/noteCarryForward.svg").default,
  docs: require("./Assets/Images/docs.svg").default,
  excel: require("./Assets/Images/excel.svg").default,
  docx: require("./Assets/Images/docx.svg").default,
  jpeg: require("./Assets/Images/jpeg.svg").default,
  png: require("./Assets/Images/png.svg").default,
  jpg: require("./Assets/Images/jpg.svg").default,
  file: require("./Assets/Images/file.svg").default,
  addNoteGray: require("./Assets/Images/addNoteGray.svg").default,
};
export default images;
